// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"_2EQdvVx4KcK4GAOr2dyl-N","searchIcon":"_1l15FdbhCKjA8H2CPR2OtD"};